import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function DollarFilled({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <DollarFilled.Outline {...props} />
  ) : (
    <DollarFilled.Solid {...props} />
  );
}

DollarFilled.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="1.5"
          className="icon-outline"
        />
        <path
          d="M12 6V18"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          className="icon-outline"
        />
        <path
          d="M15 9.5C15 8.12 13.66 7 12 7C10.34 7 9 8.12 9 9.5C9 10.88 10.34 12 12 12C13.66 12 15 13.12 15 14.5C15 15.88 13.66 17 12 17C10.34 17 9 15.88 9 14.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

DollarFilled.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <circle
          cx="12"
          cy="12"
          r="12"
          opacity="0.4"
          className="icon-secondary"
        />
        <path
          d="M12.74 15.35C13.22 15.29 13.58 15.14 13.82 14.88C14.07 14.63 14.19 14.3 14.19 13.89C14.19 13.72 14.16 13.57 14.1 13.44C14.03 13.31 13.94 13.2 13.83 13.11C13.72 13.01 13.59 12.93 13.44 12.86C13.29 12.79 13.13 12.72 12.95 12.66L12.74 15.35ZM12.45 8.74C12.21 8.77 12 8.82 11.83 8.89C11.66 8.97 11.51 9.06 11.4 9.16C11.29 9.27 11.21 9.39 11.16 9.52C11.1 9.65 11.08 9.79 11.08 9.94C11.08 10.11 11.11 10.25 11.17 10.38C11.23 10.51 11.31 10.62 11.41 10.72C11.52 10.82 11.65 10.91 11.79 10.98C11.94 11.05 12.09 11.12 12.26 11.19L12.45 8.74ZM13.05 11.44C13.33 11.53 13.62 11.62 13.9 11.73C14.18 11.84 14.44 11.97 14.66 12.14C14.88 12.3 15.06 12.51 15.2 12.76C15.34 13.01 15.41 13.32 15.41 13.69C15.41 14.05 15.35 14.4 15.22 14.72C15.1 15.04 14.93 15.32 14.69 15.57C14.45 15.82 14.16 16.02 13.82 16.17C13.48 16.32 13.09 16.41 12.66 16.44L12.58 17.4C12.58 17.49 12.55 17.56 12.48 17.63C12.42 17.7 12.34 17.74 12.24 17.74H11.76L11.86 16.42C11.39 16.37 10.95 16.24 10.54 16.05C10.13 15.86 9.79 15.61 9.5 15.32L9.89 14.73C9.93 14.67 9.97 14.63 10.03 14.6C10.09 14.56 10.15 14.55 10.22 14.55C10.3 14.55 10.39 14.58 10.49 14.65C10.59 14.72 10.71 14.8 10.84 14.89C10.97 14.98 11.13 15.06 11.31 15.15C11.49 15.24 11.7 15.3 11.94 15.34L12.16 12.43C11.88 12.34 11.61 12.25 11.33 12.15C11.06 12.04 10.81 11.9 10.59 11.72C10.38 11.54 10.2 11.32 10.06 11.06C9.93 10.8 9.87 10.46 9.87 10.06C9.87 9.76 9.92 9.47 10.04 9.19C10.16 8.9 10.33 8.65 10.56 8.43C10.78 8.21 11.06 8.03 11.4 7.89C11.73 7.74 12.11 7.66 12.54 7.64L12.6 6.84C12.6 6.75 12.63 6.67 12.7 6.6C12.76 6.53 12.84 6.5 12.94 6.5H13.42L13.33 7.68C13.75 7.74 14.12 7.85 14.43 8.02C14.73 8.19 15 8.39 15.23 8.61L14.92 9.09C14.83 9.23 14.72 9.3 14.59 9.3C14.53 9.3 14.46 9.28 14.38 9.24C14.3 9.19 14.2 9.14 14.09 9.08C13.98 9.02 13.86 8.96 13.72 8.9C13.58 8.84 13.42 8.79 13.25 8.76L13.05 11.44Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
